import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { Portal } from 'js/app/components/system/Portal';
import { LocalPopup as LocalPopupOriginal } from 'js/components/common/Popup/LocalPopup';

import { LOCAL_POPUP_ID } from 'js/components/common/Popup/buzz/constants';
import { setShowLocalPopup } from 'js/components/system/App/store/buzz/actions';

const LocalPopupWrap = ({ isUsePortal, children }) => {
    if (isUsePortal) {
        return (
            <Portal id={LOCAL_POPUP_ID}>
                {children}
            </Portal>
        );
    }

    return children;
};

export const LocalPopup = ({ isUsePortal = true, ...props }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setShowLocalPopup(true));

        return () => {
            dispatch(setShowLocalPopup(false));
        };
    }, [dispatch]);

    return (
        <LocalPopupWrap isUsePortal={isUsePortal}>
            <LocalPopupOriginal {...props} />
        </LocalPopupWrap>
    );
};
